import type { Policyholder } from '@/shared/api/resources';
import { useAuth } from '@/shared/auth/useAuth';
import { Card, CardBody, CardHeader } from '@/shared/ui/Card';

import { DadosDoLeiloeiro } from '../DadosDoLeiloeiro';

/**
 * Secao "Dados do Leiloeiro" do tomador pessoa fisica (P-NCT-3): o "tipo" leiloeiro, a
 * UF da junta comercial da matricula e o numero da matricula. A corretora edita o
 * proprio tomador, como edita o cadastro; o servidor confere empresa, escopo e
 * permissao.
 */
export function SecaoLeiloeiro({ tomador }: { tomador: Policyholder }) {
  const { can } = useAuth();
  return (
    <Card>
      <CardHeader
        title="Dados do Leiloeiro"
        description="O tomador pessoa fisica leiloeiro, com a junta comercial e a matricula."
      />
      <CardBody>
        <DadosDoLeiloeiro
          policyholderId={tomador.id}
          podeEditar={can('tomadores.tomador.update')}
        />
      </CardBody>
    </Card>
  );
}
